<template>
<div id="ColInput">
  <el-tooltip :disabled="hideTooltip" :content="value" placement="top">
    <el-input
        class="select-input"
        :maxlength="32"
        v-model.trim="value"
        placeholder="请输入"
        :style="{width:'100%'}"
        :disabled="row.isOffline"
        @focus="getFocus"
        @change="handleChange"
    />
  </el-tooltip>
</div>
</template>

<script>
export default {
  name: 'ColInput',
  props: {
    row: {
      type: Object,
      required: true
    },
    property: {
      type: String,
      default: ''
    },
    defaultValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: '',
      tempValue: null
    }
  },
  computed: {
    hideTooltip() {
      return (this.value && this.value.length < 7) || !this.value
    }
  },
  watch: {
    defaultValue: {
      handler(newVal) {
        this.value = newVal
      },
      immediate: true
    }
  },
  methods: {
    getFocus(e) {
      this.tempValue = e.target.value
    },
    async handleChange() {
      if (this.tempValue === this.value) {
        return
      }
      this.$emit('handle-editing', true)
      const { row, property } = this
      const { projectId, id } = row
      try {
        await this.$api.project.updateProduct(projectId, id, {
          [property]: this.value
        })
        this.$message.success('编辑成功')
      } catch (error) {
        this.$message.error('编辑失败')
        this.value = this.tempValue
      } finally {
        this.$emit('update-value', this.value)
        this.$emit('handle-editing', false)
      }
    }
  }
}
</script>

<style scoped>

</style>
